// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { defaultText, heading4, paragraph2 } from '../text'

type Props = {|
  image: {
    src: string,
    alt: string,
    height?: string,
    width?: string,
  },
  title: string,
  paragraph: string,
|}

export default function ImageText({ image, title, paragraph }: Props) {
  return (
    <Root>
      <ImageWrapper>
        <Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          loading="lazy"
        />
      </ImageWrapper>
      <TextSection>
        <Title>{title}</Title>
        <Paragraph>{paragraph}</Paragraph>
      </TextSection>
    </Root>
  )
}
const ImageWrapper = styled.div`
  max-height: 225px;
  ${media.mq[1]} {
    max-height: 280px;
  }
`
const Image = styled.img`
  width: 100%;
  height: auto;
`

const Paragraph = styled.p`
  ${paragraph2};
  color: ${colors.beige};
  margin-top: 23px;

  ${media.mq[1]} {
    margin-top: 8px;
  }
`

const TextSection = styled.div`
  padding: 30px;
  background-color: ${colors.darkPurple};
  color: ${colors.beige};
  min-height: 200px;

  ${media.mq[1]} {
    padding: 30px 35px 50px 45px;
    &:hover {
      background: ${colors.fadedPurpleAlt};
    }
  }
`

const Title = styled.h5`
  ${heading4};
  background: ${colors.darkPurple};
  color: ${colors.almostWhite};
  display: inline-block;
  border-radius: 16px;

  ${media.mq[1]} {
    background: transparent;
    color: ${(p) => p.theme.primary};
    padding: 0;
    margin-bottom: 10px;
  }
`

const Root: React.ComponentType<any> = styled.div`
  ${defaultText};
  display: flex;
  flex-direction: column;
  width: 280px;

  ${media.mq[1]} {
    width: 345px;
  }
`
